import { jsx } from "react/jsx-runtime";
import { getConfigurationSettingByDevelopmentKey, ConfigContentType } from "../../../../services/content/config.lib.js";
import { WarehouseHoursUI } from "./WarehouseHoursUI.js";
async function WarehouseHours() {
  var _a, _b;
  let config;
  try {
    config = await getConfigurationSettingByDevelopmentKey(
      ConfigContentType.ServiceConfiguration,
      "warehouse_locator_api"
    );
    if (!config) {
      return null;
    }
  } catch (error) {
    console.warn(
      "An error occurred while fetching Service_Configuration warehouse_locator_api :",
      error
    );
    return null;
  }
  const templatedEndpoint = `${config.endpoint.replace(/\.json$/, "")}/{{warehouse_id}}.json`;
  const clientId = (_a = config.required_request_parameters) == null ? void 0 : _a.client_id;
  const clientIdentifier = (_b = config.required_request_headers) == null ? void 0 : _b.client_identifier;
  let url = templatedEndpoint;
  let headers;
  if (clientIdentifier) {
    headers = { "client-identifier": clientIdentifier };
  } else if (clientId) {
    url = `${templatedEndpoint}?client_id=${clientId}`;
  }
  return /* @__PURE__ */ jsx(WarehouseHoursUI, { url, headers });
}
export {
  WarehouseHours
};
